/* @flow strict */

import * as React from 'react';
// import t from 'client/src/utils/i18nCheckKey';

export type PropsType = {
  onClick: () => void,
  progress: number,
  children: React.Node
};

const Pending = ({
  onClick: handleClick,
  progress,
  children
}: Props): React.Element<'div'> => (
  <div className="Loader__wrapper">
    <span>
      <button className="Loader csspinner" onClick={handleClick}>
        {children}
        {progress && progress > 0 ? (
          <span className="Loader__progress Loader__progress--progress">
            {progress}%
          </span>
        ) : null}
      </button>
    </span>
  </div>
);

Pending.defaultProps = {
  children: null,
  progress: 0
};

export default Pending;
